import {RateModelSelectorProps, rateModelsSelector, useGetAllRateModelsQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseRateModelSelect, BaseRateModelSelectProps} from "./BaseRateModelSelect";

type Props = Omit<BaseRateModelSelectProps, 'entities' | 'loading'> & {
  selector?: RateModelSelectorProps
};

export const RateModelSelect = (props: Props) => {
  const {selector, ...rest} = props;

  const selectRateModels = useMemo(() => {
    return rateModelsSelector()
  }, [])

  const {rateModels, isLoading} = useGetAllRateModelsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      rateModels: selectRateModels(result, selector),
      isLoading: result.isLoading,
    })
  });

  return <BaseRateModelSelect entities={rateModels} loading={isLoading} {...rest} />;
};
